import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-technology-domain',
  standalone: false,
  template: `
    <app-data-table
      [columns]="cols"
      [data]="technologyDomain"
      [isCardView]="false"
      (onPresentView)="getTechnologyDomain($event)"
      [url]="'/master/technology-domain/'"
      [isDeletable]="'/master/technology-domain' | hasPermission: 'Delete'"
      [showAddButton]="true"
      [showActions]="canEditSetup"
      [isEditable]="'/master/technology-domain' | hasPermission: 'Edit'"
      [title]="'Technology Domain'"
      (onAdd)="addTechnologyDomain()"
      (editEventRow)="updateTechnologyDomain($event)"
      [isView]="'/master/technology-domain' | hasPermission: 'View'"
      (viewEventRow)="viewTechnologyDomain($event)"
      (deleteEventRow)="showDeletePopup($event)"
      (onLazyLoadData)="getTechnologyDomain($event)">
    </app-data-table>

    <!-- Edit/View Dialog -->
    <app-reusable-dialog
      [(visible)]="isUpdatedialog"
      [config]="updateDialogConfig"
      [initialData]="selectedTechnologyDomainData"
      [viewMode]="viewMode"
      (onSubmit)="onSubmitUpdate($event)"
      (onCancel)="onCancelDialog()"
      (onClose)="onCloseDialog()"
    ></app-reusable-dialog>

    <!-- Delete Dialog -->
    <p-dialog header="Delete Technology Domain" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
      <div class="delete-dialog  mt-3">
        <i class="pi pi-trash text-danger custom-delete-icon"></i>
        <span>Are you sure , you want to delete technology domain ?</span>
        <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteTechnologyDomain()" class="mt-2" ></p-button>
      </div>
    </p-dialog>

    <!-- Add Dialog -->
    <app-reusable-dialog
      [(visible)]="showDialog"
      [config]="addDialogConfig"
      [initialData]="{}"
      [viewMode]="false"
      (onSubmit)="onSubmitAdd($event)"  
      (onCancel)="onCancelDialog()"
      (onClose)="onCloseDialog()"
    ></app-reusable-dialog>
  `,
})
export class TechnologyDomainComponent implements OnInit {
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  showDeleteDialog: boolean = false;
  selectedTechnologyDomainData: any = {};
  viewMode = false;
  addDialogConfig: DialogConfig;
  updateDialogConfig: DialogConfig;
  cols: any[] = [
    { field: 'name', header: 'Name', filterType: 'text', width: '200px' },
    { field: 'description', header: 'Description', filterType: 'text', width: '350px' },
    { field: 'is_active', header: 'Status', filterType: 'text', width: '120px', body: (row: any) => row.is_active === 1 ? 'Active' : 'Inactive' }
  ];
  technologyDomain: any[] = [];
  deleteTarget: any = null;

  constructor(
    private apiService: ApiService,
    private permissionService: PermissionsService
  ) {}

  ngOnInit(): void {
    this.getTechnologyDomain({ page: 1 });
    this.initializeDialogConfigs();
  }

  getTechnologyDomain(event: any = { page: 1, search: '' }): void {
    // Optionally handle pagination/search, but basic fetch for now
    this.apiService.getAPI('/master/technology-domain/').subscribe((res: any) => {
      // Support list or paginated format
      if (Array.isArray(res)) {
        this.technologyDomain = res;
      } else if (res?.data?.results) {
        this.technologyDomain = res.data.results;
      } else if (res?.results) {
        this.technologyDomain = res.results;
      } else if (res?.data) {
        this.technologyDomain = res.data;
      } else {
        this.technologyDomain = [];
      }
    });
  }

  addTechnologyDomain(): void {
    this.selectedTechnologyDomainData = {};
    this.showDialog = true;
    this.viewMode = false;
  }

  updateTechnologyDomain(event: any): void {
    this.selectedTechnologyDomainData = { ...event };
    this.isUpdatedialog = true;
    this.viewMode = false;
  }

  viewTechnologyDomain(event: any): void {
    this.selectedTechnologyDomainData = { ...event };
    this.isUpdatedialog = true;
    this.viewMode = true;
  }

  showDeletePopup(event: any): void {
    this.deleteTarget = event;
    this.showDeleteDialog = true;
  }

  deleteTechnologyDomain(): void {
    if (!this.deleteTarget?.id) {
      this.showDeleteDialog = false;
      return;
    }
    this.apiService.postAPI(`/master/technology-domain/`, {id: this.deleteTarget.id, action: 'delete'})
      .subscribe((res: any) => {
        if (res) {
          this.showDeleteDialog = false;
          this.getTechnologyDomain({ page: 1 });
        }
      });
  }

  private initializeDialogConfigs(): void {
    // Add Dialog Configuration
    this.addDialogConfig = {
      title: 'Add New Technology Domain',
      width: '80vw',
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-fund-dialog',
      formLayout: 'single-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      fields: [
        {
          key: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Enter Name',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: "Name must be alphanumeric and can include spaces and '&' only."
        },
        {
          key: 'description',
          label: 'Description',
          type: 'text',
          placeholder: 'Enter Description',
          maxLength: 500,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: "Description must be alphanumeric and can include spaces and '&' only."
        }
      ]
    };

    // Update/View Dialog Configuration
    this.updateDialogConfig = {
      title: 'Update Technology Domain',
      width: '80vw',
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-fund-dialog',
      formLayout: 'two-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      fields: [
        {
          key: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Enter Name',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: "Name must be alphanumeric and can include spaces and '&' only."
        },
        {
          key: 'description',
          label: 'Description',
          type: 'textarea',
          placeholder: 'Enter Description',
          maxLength: 500,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: "Description must be alphanumeric and can include spaces and '&' only."
        },
        {
          key: 'is_active',
          label: 'Active',
          type: 'checkbox'
        }
      ]
    };
  }

  onSubmitAdd(formData: any): void {
    const payload = {
      action: 'create',
      name: formData.name,
      description: formData.description,
      is_active: 1
    };

    this.apiService.postAPI('/master/technology-domain/', payload).subscribe((res: any) => {
      if (res) {
        this.showDialog = false;
        this.getTechnologyDomain({ page: 1 });
      }
    });
  }

  onSubmitUpdate(formData: any): void {
    const payload = {
      action: 'update',
      id: this.selectedTechnologyDomainData.id,
      name: formData.name,
      description: formData.description,
      is_active: formData.is_active ? 1 : 0
    };

    this.apiService
      .putAPI(
        `/master/technology-domain/${this.selectedTechnologyDomainData.id}/`,
        payload
      )
      .subscribe((res: any) => {
        if (res) {
          this.isUpdatedialog = false;
          this.getTechnologyDomain({ page: 1 });
          this.viewMode = false;
        }
      });
  }

  onCancelDialog(): void {
    this.showDialog = false;
    this.isUpdatedialog = false;
    this.selectedTechnologyDomainData = {};
    this.viewMode = false;
  }

  onCloseDialog(): void {
    this.showDialog = false;
    this.isUpdatedialog = false;
    this.selectedTechnologyDomainData = {};
    this.viewMode = false;
  }

  get canEditSetup(): boolean {
    return (
      this.permissionService.hasPrivilege(
        '/master/technology-domain',
        'Edit'
      ) ||
      this.permissionService.hasPrivilege(
        '/master/technology-domain',
        'Delete'
      ) ||
      this.permissionService.hasPrivilege(
        '/master/technology-domain',
        'View'
      )
    );
  }
}
